// payment types
export const PAYMENT_METHOD_CREDITCARD = 'creditcard'
export const PAYMENT_METHOD_GIROPAY = 'giropay'
export const PAYMENT_METHOD_SOFORT = 'sofort'

// payment states
export const PAYMENT_STATE_PENDING = 'pending'
export const PAYMENT_STATE_ERROR = 'error'

// stripe state
export const STRIPE_SUCCESS_STATUS = 'succeeded'

// invoice states
export const INVOICE_STATE_DRAFT = 'draft'
export const INVOICE_STATE_LOCKED = 'locked'
export const INVOICE_STATE_PARTIALLYPAID = 'partiallyPaid'
export const INVOICE_STATE_DUNNED = 'dunned'
export const INVOICE_STATE_PAID = 'paid'
export const INVOICE_STATE_CANCELLED = 'cancelled'
export const INVOICE_PAYABLE_STATES = [
  INVOICE_STATE_DUNNED,
  INVOICE_STATE_PARTIALLYPAID,
  INVOICE_STATE_LOCKED
]

// mimetypes
export const MIMETYPE_PDF = 'application/pdf'

// checkout states
export const CHECKOUT_STATE_INTRODUCTION = 'introduction'
export const CHECKOUT_STATE_CHECKOUT = 'checkout'
export const CHECKOUT_STATE_PENDING = 'pending'
export const CHECKOUT_STATE_SUCCESS = 'success'
export const CHECKOUT_STATE_ERROR = 'error'
export const CHECKOUT_STATE_LOADING = 'loading'

// transaction status
export const TRANSACTION_STATUS_OPEN = 'locked'
export const TRANSACTION_STATUS_PAID = 'paid'



// WEBPACK FOOTER //
// ./src/constants.js